import propsTypes from "prop-types";
import { colors } from "../../assets/styles";
import Spinner from "../spinner/Spinner";
import { ButtonStyle } from "./style";
import "./styles.css";

const Primary = ({
  title,
  isLoading,
  className,
  children,
  onClick,
  sizeSpinner,
  colorSpinner,
  icon,
  seq,
  containerClass,
  refrence,
}) => {
  const onPress = (e) => {
    e.preventDefault();

    if (isLoading === false) {
      onClick();
    }
  };

  return (
    <>
      <ButtonStyle className={containerClass} isLoading={isLoading}>
        <a
          ref={refrence}
          href="/"
          className={`btn-custom text-center border ${
            seq ? "seq" : false
          } ${className}`}
          style={{
            backgroundColor: colors.colorWhite,
            borderColor: colors.textColorBlackOne,
            color: colors.textColorBlack,
          }}
          onClick={onPress}
        >
          {isLoading ? (
            <Spinner size={sizeSpinner} color={colorSpinner} />
          ) : (
            <>
              {icon}
              {title}
              {children}
            </>
          )}
        </a>
      </ButtonStyle>
    </>
  );
};

Primary.propsTypes = {
  title: propsTypes.string,
  isLoading: propsTypes.bool,
  className: propsTypes.string,
  containerClass: propsTypes.string,
  children: propsTypes.element,
  onClick: propsTypes.func,
  sizeSpinner: propsTypes.number,
  colorSpinner: propsTypes.string,
  icon: propsTypes.elementType,
  seq: propsTypes.bool,
};

Primary.defaultProps = {
  title: "",
  isLoading: false,
  seq: false,
};

export default Primary;
